/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * WHO a Drop is for. One member per customer shape we actually sell.
 * CREATOR - individual streamer/creator. Default for OAuth signups.
 * PUBLISHER - a games publisher's own presence, across its titles.
 * FRANCHISE - a series spanning titles, between publisher and game.
 *   Activision is the PUBLISHER, Call of Duty the FRANCHISE, Modern
 *   Warfare 4 the GAME.
 * GAME - a single title's page, distinct from its franchise's.
 * COMMUNITY - clans and groups that are none of the above.
 * ESPORTS_PROFESSIONAL - a professional org with a roster and a schedule.
 * ESPORTS_COLLEGIATE - an academic programme: rosters carrying class
 *   years, a coach, an arena, tryouts.
 * BRAND - a brand's presence in the Drop-In network.
 * AGENCY - represents others: a creator talent agency, a production or
 *   marketing agency. Public or private — a creator agency's roster is
 *   its marketing, a talent-rep shop's client list is commercially
 *   sensitive, and both are the same page with a different visibility.
 * 
 * @export
 */
export const DropType = {
    CREATOR: 'CREATOR',
    PUBLISHER: 'PUBLISHER',
    FRANCHISE: 'FRANCHISE',
    GAME: 'GAME',
    COMMUNITY: 'COMMUNITY',
    ESPORTS_PROFESSIONAL: 'ESPORTS_PROFESSIONAL',
    ESPORTS_COLLEGIATE: 'ESPORTS_COLLEGIATE',
    BRAND: 'BRAND',
    AGENCY: 'AGENCY'
} as const;
export type DropType = typeof DropType[keyof typeof DropType];


export function instanceOfDropType(value: any): boolean {
    for (const key in DropType) {
        if (Object.prototype.hasOwnProperty.call(DropType, key)) {
            if (DropType[key as keyof typeof DropType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DropTypeFromJSON(json: any): DropType {
    return DropTypeFromJSONTyped(json, false);
}

export function DropTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropType {
    return json as DropType;
}

export function DropTypeToJSON(value?: DropType | null): any {
    return value as any;
}

export function DropTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DropType {
    return value as DropType;
}

